import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=3b670d52&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Login.vue?vue&type=style&index=1&id=3b670d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b670d52",
  null
  
)

export default component.exports